var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPige(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#E74536",
    rx: 42.667
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.333 24)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 114.667,
    cy: 112,
    r: 98.667,
    fill: "#0F1941"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.667,
    cy: 98.667,
    r: 98.667,
    fill: "#F7F5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB511",
    d: "M130.486 87.832h-13.469l15.137-72.285c1.418-6.77-7.713-10.47-11.54-4.676l-61.99 93.863c-2.748 4.162.283 9.668 5.322 9.668h10.716l-20.949 56.636c-2.174 5.877 5.511 10.368 9.7 5.669l71.208-79.872c3.123-3.504.6-9.003-4.135-9.003z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgMjU2IDI1NiI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxyZWN0IHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiBmaWxsPSIjRTc0NTM2IiByeD0iNDIuNjY3Ii8+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjEuMzMzIDI0KSI+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjExNC42NjciIGN5PSIxMTIiIHI9Ijk4LjY2NyIgZmlsbD0iIzBGMTk0MSIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSI5OC42NjciIGN5PSI5OC42NjciIHI9Ijk4LjY2NyIgZmlsbD0iI0Y3RjVGMCIvPgogICAgICAgICAgICA8cGF0aCBmaWxsPSIjRkZCNTExIiBkPSJNMTMwLjQ4NiA4Ny44MzJoLTEzLjQ2OWwxNS4xMzctNzIuMjg1YzEuNDE4LTYuNzctNy43MTMtMTAuNDctMTEuNTQtNC42NzZsLTYxLjk5IDkzLjg2M2MtMi43NDggNC4xNjIuMjgzIDkuNjY4IDUuMzIyIDkuNjY4aDEwLjcxNmwtMjAuOTQ5IDU2LjYzNmMtMi4xNzQgNS44NzcgNS41MTEgMTAuMzY4IDkuNyA1LjY2OWw3MS4yMDgtNzkuODcyYzMuMTIzLTMuNTA0LjYtOS4wMDMtNC4xMzUtOS4wMDN6Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgLogoPige as ReactComponent };